import { useEffect, useState } from 'react';

import { useAuthStore } from '@/stores/auth-store';

/**
 * Retourne true une fois que Zustand a fini de lire le localStorage.
 * Utilise l'API persist native de Zustand v5 (hasHydrated / onFinishHydration)
 * pour éviter les race conditions avec onRehydrateStorage.
 */
export function useHydration(): boolean {
  const [hydrated, setHydrated] = useState<boolean>(() => useAuthStore.persist.hasHydrated());

  useEffect(() => {
    if (useAuthStore.persist.hasHydrated()) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHydrated(true);
      return;
    }
    return useAuthStore.persist.onFinishHydration(() => setHydrated(true));
  }, []);

  return hydrated;
}
